export const messages = {
  title: { id: 'admin/promotions.form.conditions.shipping-location' },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.shipping-location.view.title',
    },
    shippingCountries: {
      id: 'admin/promotions.form.conditions.shipping-location.view.shipping-countries',
    },
    zipCodeRange: {
      id: 'admin/promotions.form.conditions.shipping-location.view.zip-code',
    },
    range: {
      id: 'admin/promotions.form.conditions.shipping-location.view.zip-code.range',
    },
  },
  editor: {
    subtitle: {
      id: 'admin/promotions.form.conditions.shipping-location.subtitle',
    },
    shippingCountries: {
      id: 'admin/promotions.form.conditions.shipping-location.editor.shipping-countries',
    },
    zipCodeRanges: {
      id: 'admin/promotions.form.conditions.shipping-location.editor.zip-code-ranges',
    },
    zipCodeRangeEditor: {
      statement: {
        id: 'admin/promotions.form.conditions.zip-code-ranges.statement',
      },
      operator: {
        label: {
          id: 'admin/promotions.form.conditions.zip-code-ranges.operator.label',
        },
        include: {
          id: 'admin/promotions.form.conditions.zip-code-ranges.include',
        },
        exclude: {
          id: 'admin/promotions.form.conditions.zip-code-ranges.exclude',
        },
      },
      range: {
        from: {
          id: 'admin/promotions.form.conditions.zip-code-ranges.from.label',
        },
        to: { id: 'admin/promotions.form.conditions.zip-code-ranges.to.label' },
        remove: {
          id: 'admin/promotions.form.conditions.zip-code-ranges.remove-range',
        },
      },
      addRange: {
        id: 'admin/promotions.form.conditions.zip-code-ranges.add-range',
      },
    },
  },
  validation: {
    required: {
      id: 'admin/promotions.form.validation.required',
    },
    endGreatherThanStart: {
      id: 'admin/promotions.form.conditions.zip-code-ranges.validation.end-must-be-greather-than-start',
    },
    duplicated: {
      id: 'admin/promotions.form.conditions.zip-code-ranges.validation.unique',
    },
  },
}
